module.exports = __webpack_public_path__ + "static/8-f309537f0e6f392e9079d6471ddfe834.jpg";